import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

const STORAGE_KEY = 'cookie_consent';
// Zustimmung aus der früheren CookieConsent-Komponente: verhindert, dass
// bestehende Nutzer den Hinweis erneut sehen. Kann entfallen, wenn alle den
// neuen Text einmal sehen sollen.
const LEGACY_STORAGE_KEY = 'cookieConsentDate';

/**
 * CookieBanner – informativer Hinweis am unteren Bildschirmrand.
 *
 * Es gibt keine Wahl zwischen Annehmen und Ablehnen: die Seite setzt keine
 * Tracking-Cookies, die Bestätigung ist reine Kenntnisnahme.
 * Wird erst nach der Startsequenz gerendert (s. App.jsx).
 *
 * `onDismissed` meldet, dass der Platz am unteren Rand wieder frei ist – auch
 * dann, wenn nie ein Banner erschien, weil die Zustimmung schon vorlag.
 */
const CookieBanner = ({ onDismissed }) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consented =
      localStorage.getItem(STORAGE_KEY) || localStorage.getItem(LEGACY_STORAGE_KEY);
    if (consented) onDismissed?.();
    else setVisible(true);
  }, [onDismissed]);

  const handleConfirm = () => {
    localStorage.setItem(STORAGE_KEY, new Date().toISOString());
    setVisible(false);
    onDismissed?.();
  };

  if (!visible) return null;

  return (
    <div className="cookie-banner" role="region" aria-label="Cookie-Hinweis">
      <div className="cookie-banner__content">
        <p className="cookie-banner__text body Font-S-B-130-T">
          Diese Website verwendet nur notwendige Cookies, um Inhalte der Website anzuzeigen und die Funktionalität zu gewährleisten.
          Weitere Informationen finden Sie in unserer{' '}
          <Link to="/datenschutz" className="cookie-banner__link">
            Datenschutzerklärung
          </Link>
          .
        </p>
        <button type="button" className="btn btn-primary cookie-banner__btn" onClick={handleConfirm}>
          Verstanden
        </button>
      </div>
    </div>
  );
};

export default CookieBanner;
